export default __webpack_public_path__ + "static/media/panneau-utilisateur.c56aa836.svg";